import React, { useEffect } from "react";

const PoliticaPrivacidad = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="min-h-screen bg-gray-50 pt-24 pb-16 font-dmSans">
            <div className="max-w-4xl mx-auto px-5">
                <div className="bg-white rounded-[24px] shadow-sm border border-gray-100 p-8 md:p-12">
                    <div className="mb-10 border-b border-gray-100 pb-8">
                        <h1 className="text-3xl md:text-4xl font-bold text-[#7A1B29] mb-3">
                            Política de Privacidad
                        </h1>
                        <p className="text-gray-500">Última actualización: {new Date().toLocaleDateString('es-AR')}</p>
                    </div>

                    <div className="space-y-8 text-gray-700 leading-relaxed">
                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">1. Recopilación de Datos Personales</h2>
                            <p>
                                En Inmobiliaria D'Williams respetamos su privacidad. A través de nuestros formularios de contacto, botones de WhatsApp y correos electrónicos, podemos recopilar información personal como su nombre, número de teléfono, dirección de correo electrónico e información sobre sus preferencias de búsqueda inmobiliaria.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">2. Uso de la Información</h2>
                            <p>
                                Los datos personales recolectados son utilizados exclusivamente con los siguientes fines:
                            </p>
                            <ul className="list-disc pl-5 mt-2 space-y-1">
                                <li>Responder a sus consultas sobre propiedades.</li>
                                <li>Coordinar visitas a los inmuebles.</li>
                                <li>Enviar información relevante sobre nuevas propiedades u oportunidades de inversión (siempre que lo haya consentido).</li>
                                <li>Procesos administrativos internos para la tasación, venta o alquiler de propiedades.</li>
                            </ul>
                            <p className="mt-4">
                                En ningún caso Inmobiliaria D'Williams comercializará, cederá ni compartirá sus datos personales con terceros con fines publicitarios ajenos a nuestra firma.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">3. Seguridad de los Datos</h2>
                            <p>
                                Adoptamos las medidas técnicas y organizativas necesarias para garantizar la seguridad y confidencialidad de sus datos personales, con el fin de evitar su alteración, pérdida, tratamiento o acceso no autorizado.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-gray-900 mb-3">4. Derechos del Titular de los Datos (Ley 25.326)</h2>
                            <p>
                                De acuerdo con la <strong>Ley de Protección de Datos Personales (Ley N° 25.326)</strong> de la República Argentina, usted tiene derecho a solicitar el acceso, la rectificación, la actualización o la supresión de sus datos personales incluidos en nuestra base de datos en cualquier momento.
                            </p>
                            <p className="mt-2">
                                Para ejercer estos derechos, puede comunicarse con nosotros enviando un correo electrónico a <strong>info@dwilliams.com.ar</strong> o a través de nuestros canales de contacto oficiales.
                            </p>
                        </section>

                        {/* AVISO OBLIGATORIO AAIP */}
                        <section className="mt-12 bg-gray-50 p-6 rounded-xl border border-gray-200">
                            <div className="flex flex-col md:flex-row items-center gap-6">
                                <div className="flex-1">
                                    <h3 className="font-bold text-gray-900 text-sm uppercase tracking-wider mb-2">Órgano de Control</h3>
                                    <p className="text-sm text-gray-600 text-justify">
                                        <em>"La Agencia de Acceso a la Información Pública, en su carácter de Órgano de Control de la Ley N° 25.326, tiene la atribución de atender las denuncias y reclamos que interpongan quienes resulten afectados en sus derechos por incumplimiento de las normas vigentes en materia de protección de datos personales."</em>
                                    </p>
                                    <a
                                        href="https://www.argentina.gob.ar/aaip/datospersonales"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="inline-block mt-3 text-sm font-bold text-[#7A1B29] hover:underline"
                                    >
                                        Conocer más sobre mis derechos →
                                    </a>
                                </div>
                                <div className="w-40 shrink-0">
                                    {/* Se coloca el logo oficial del gobierno que te da la AAIP, u omitir si prefieres dejar solo texto */}
                                    <img
                                        src="https://www.argentina.gob.ar/sites/default/files/aaip_logo.png"
                                        alt="Agencia de Acceso a la Información Pública"
                                        className="w-full grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all"
                                    />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PoliticaPrivacidad;